import { lazy } from 'react';

/** Открывает раздел общей очереди операторов */
export const OperatorTasksPageAsync = lazy(() => import('./OperatorTasksPage').then((module) => ({ default: module.OperatorTasksPage })));
